import React from 'react'
import AppContext from '../context/app'
import Navbar from '../components/navbar'
import InMusic from '../components/inmusic'
import Footer from '../components/footer'
import Violator from '../components/violator'
import useGetAppValue from '../hooks/useGetAppValue'
import useWindowEventListenersEffect from '../hooks/useWindowEventListenersEffect'
import useCountryEffect from '../hooks/useCountryEffect'
import useCartIdEffect from '../hooks/useCartIdEffect'
import { ThemeProvider } from '@emotion/react'
import * as styles from '../styles/exports.module.scss'
import Modal from 'react-bootstrap/Modal'

export default function MainLayout({ children }) {
    const value = useGetAppValue()
    const {
        isModalOpen,
        globalModalChildren,
        setGlobalModalChildren,
    } = value

    useWindowEventListenersEffect(value)
    useCountryEffect(value)
    useCartIdEffect(value)

    const theme = {
        colors: {
            primary: styles.primaryColor,
            secondary: styles.secondaryColor,
            light: styles.lightColor,
            dark: styles.darkColor,
            info: styles.infoColor,
        },
        fonts: {
            montserrat: styles.montserratFont,
        }
    }

    return (
        <AppContext.Provider value={value}>
            <ThemeProvider theme={theme}>
                <Violator />

                <Navbar
                    className='p-0'
                    style={{ zIndex: isModalOpen ? 2 : 3 }}
                />
                
                <main
                    className='position-relative'
                    style={{ zIndex: isModalOpen ? 3 : 2 }}
                >
                    {children}
                </main>
                
                <footer
                    className='position-relative'
                    style={{ zIndex: 1 }}
                >
                    <InMusic />
                    <Footer />
                </footer>
                
                <Modal
                    size='xl'
                    centered
                    show={Boolean(globalModalChildren)}
                    onHide={() => setGlobalModalChildren(undefined)}
                    css={{ '& .modal-content': { background: 0, border: 'none' }}}
                >
                    <button
                        onClick={() => setGlobalModalChildren(undefined)}
                        css={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            background: 'none',
                            border: 'none',
                            width: 40,
                            height: 40,
                            color: '#fff',
                            fontSize: 40,
                            lineHeight: 1,
                            cursor: 'pointer',
                            zIndex: 10,
                        }}
                        aria-label='Close'
                    >
                        &times;
                    </button>
                    {globalModalChildren}
                </Modal>
            </ThemeProvider>
        </AppContext.Provider>
    )
}